import { component as defineComponent } from 'flightjs';

var eliminateDesignerButton = function () {
    this.after('initialize', function () {
        this.on('click', this.triggerEliminateDesigner);
    });

    this.triggerEliminateDesigner = function (event) {
        var data = this.$node.data();
        if (this.$node.is('[data-disabled]')) {
            event.stopPropagation();
            return;
        }

        this.trigger('uiEliminateDesignerRequested', data);
    };
};

export default defineComponent(eliminateDesignerButton);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/eliminate-designer-button.js